import { render } from "./Documents.vue?vue&type=template&id=1fdcd2cc"
import script from "./Documents.vue?vue&type=script&lang=ts"
export * from "./Documents.vue?vue&type=script&lang=ts"
script.render = render

export default script